<template>
  <div>
    <section class="socials-header">
      <div
        class="socials-header__title page-heading"
        v-html="activePage.heading_text"
      ></div>
      <div
        class="socials-header__subtitle page-intro"
        v-html="activePage.intro_text"
      ></div>
    </section>
    <section class="socials-holder">
      <div id="flockler-embed-17918c985d90d3b830eba7586add007d"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SocialsPage",
  metaInfo: {
    titleTemplate: "%s"
  },
  mounted() {
    this.setPageContext("socials", () => {});
    let flocklerScript = document.createElement("script");
    flocklerScript.setAttribute(
      "src",
      "https://plugins.flockler.com/embed/17306b20f4806af0ee967ed6c0e66236/17918c985d90d3b830eba7586add007d"
    );
    document.head.appendChild(flocklerScript);
  }
};
</script>

<style scoped lang="scss">
.socials-header {
  padding: 80px 40px;
  text-align: center;
  color: $primary;
}

.socials-holder {
  margin: 0 120px;
}

@media screen and (max-width: 960px) {
  .socials-holder {
    margin: 0 20px;
  }
}
</style>
